import React, { useState } from 'react'
import { Popover } from '@mui/material'
import PropTypes from 'prop-types'

import Icon from 'components/icon'
import { useI18next } from 'gatsby-plugin-react-i18next'
import { getLocaleName } from 'utils/i18n'

const PopoverSwitcher = ({ className = '' }) => {
  const { language, languages, changeLanguage } = useI18next()

  const [targetItem, setTargetItem] = useState({ el: null })

  const handlePopoverClose = () => {
    setTargetItem({ el: null })
  }
  const handlePopoverOpen = (event) => {
    setTargetItem({ el: event?.currentTarget || targetItem.el })
  }
  const isOpenItem = () => Boolean(targetItem.el)

  return (
    <div className={className}>
      <button
        className="flex h-full items-center group"
        onMouseEnter={(e) => handlePopoverOpen(e)}
        onMouseLeave={handlePopoverClose}
        style={{ minWidth: 56 }}
      >
        <Icon name="language_outlined" className="text-gray-600 group-hover:text-secondary-600" />
        <span className="font-bold pl-1 text-sm text-gray-600 group-hover:text-secondary-600">
          {getLocaleName(language)}
        </span>
      </button>
      <Popover
        anchorEl={targetItem?.el}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        classes={{ paper: `px-3 py-5 rounded-md shadow-md pointer-events-auto` }}
        className="pointer-events-none"
        disableScrollLock={true}
        open={isOpenItem()}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        PaperProps={{ onMouseEnter: () => handlePopoverOpen(null), onMouseLeave: handlePopoverClose }}
      >
        <ul aria-label="language">
          {languages.map((lang) => {
            return lang === language ? null : (
              <li key={lang} className="px-3">
                <button
                  onClick={(e) => {
                    e.preventDefault()
                    changeLanguage(lang)
                  }}
                  className="leading-9 text-gray-700 hover:text-secondary-600"
                >
                  {getLocaleName(lang)}
                </button>
              </li>
            )
          })}
        </ul>
      </Popover>
    </div>
  )
}

PopoverSwitcher.propTypes = {
  className: PropTypes.string
}

export default PopoverSwitcher
